export const GRAPHQL_API
	= 'https://api.graph.cool/simple/v1/cjnf1b39u0j0a0103q4hyp1bb/';
